import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/_providers/NavigationEvents.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/_providers/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/globals.css")